import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { z } from 'zod'
import { api, get } from './axios'

const reverbConfig = z.object({
    key: z.string(),
    host: z.string(),
    port: z.number(),
    scheme: z.string(),
})

let connection: Promise<Echo<'reverb'>> | null = null

/**
 * One connection to Reverb for the whole app, opened the first time something listens. Private channels are authorized
 * through the app's own axios instance, so an expired access token is refreshed first.
 */
export function echo(): Promise<Echo<'reverb'>> {
    connection ??= get(reverbConfig, '/broadcasting/config').then((config) => {
        const secure = config.scheme === 'https'

        return new Echo({
            broadcaster: 'reverb',
            Pusher,
            key: config.key,
            wsHost: config.host,
            wsPort: config.port,
            wssPort: config.port,
            forceTLS: secure,
            // pusher-js calls its TLS socket 'ws' too: with only 'wss' enabled it never connects.
            enabledTransports: ['ws', 'wss'],
            channelAuthorization: {
                customHandler: ({ socketId, channelName }, callback) => {
                    api.post('/broadcasting/auth', { socketId, channelName })
                        .then((response) => callback(null, response.data))
                        .catch((error) => callback(error, null))
                },
            },
        })
    })

    return connection
}
